import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getWebAbsPath } from '../util/path';
import { Carousel } from 'react-responsive-carousel';
import Url from 'url';
import join from 'url-join';
import { ApiServerUrl } from '../config.json';
import { safeGet } from '../../src/axios-default';

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            banners: [],
        };
    }

    async componentDidMount() {
        let { banners } = await safeGet(`config/getBannerByUser`);
        this.setState({ banners });
    }

    getBanner = () => {
        if (this.state.banners && this.state.banners.length) {
            return this.state.banners.map((b) => {
                const banner = {};
                if (typeof b === 'string') {
                    banner.img = b;
                    banner.url = '';
                } else {
                    banner.img = b.img;
                    banner.url = b.url;
                }
                if (banner.img.startsWith('/file') || banner.img.startsWith('file')) {
                    banner.img = join(ApiServerUrl, banner.img);
                }
                return banner;
            });
        } else {
            return [{ img: getWebAbsPath('/img/bannerSmall.jpg'), url: '' }];
        }
    };

    render() {
        return (
            <Carousel
                showArrows={true}
                autoPlay
                infiniteLoop
                showThumbs={false}
                swipeable={true}
                emulateTouch
                transitionTime={700}
                interval={10000}
            >
                {this.getBanner().map((banner, i) => {
                    let content = (
                        <img
                            src={banner.img}
                            style={{ display: 'block' }}
                            onError={({ target }) => {
                                let u = Url.parse(target.src);
                                target.src =
                                    u.pathname === '/' || u.pathname.startsWith('/img')
                                        ? ''
                                        : getWebAbsPath('/img/bannerSmall.jpg');
                            }}
                        />
                    );
                    if (String.isNotBlank(banner.url)) {
                        content = (
                            <a key={i} href={banner.url} target="_blank" style={{ display: 'block' }}>
                                {content}
                            </a>
                        );
                    }
                    return <div>{content}</div>;
                })}
            </Carousel>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.config.config,
    };
};

export default connect(mapStateToProps)(withRouter(Banner));
